import { webConfig } from './webConfig';

/**
 * Return the public endpoint for the GitBook API OAuth zone.
 */
export function getOAuthZoneEndpoint(): string {
    return `https://${webConfig.services.oauth.host}`;
}
